import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { ScrollPanel } from "primereact/scrollpanel";
import { Toast } from "primereact/toast";
import "./App.css";
import { useEffect, useRef, useState } from "react";
import { I18nextProvider } from "react-i18next";
import { Provider, useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch, useHistory } from "react-router";
import { BrowserRouter } from "react-router-dom";
import Dashboard from "./components/dashboard/dashboard";
import AddressDetails from "./components/kyc/addressDetails";
import BankDetails from "./components/kyc/bankDetails";
import BoidDetails from "./components/kyc/boidDetails";
import CompanyDetails from "./components/kyc/companyDetails";
import Decleration from "./components/kyc/declerationDetails";
import DirectorDetails from "./components/kyc/directorDetails";
import DocumentDetails from "./components/kyc/documentDetails";
import FamilyDetails from "./components/kyc/familyDetails";
import GuardianDetails from "./components/kyc/guardianDetails";
import IdentityDetails from "./components/kyc/identityDetails";
import KycSideBar from "./components/kyc/kycSidebar";
import OccupationDetails from "./components/kyc/occupationDetails";
import PersonalDetails from "./components/kyc/personalDetails";
import KycView from "./components/lookup/kycView";
import OrganizationLookup from "./components/lookup/organizationLookup";
import ChangePassword from "./components/security/changePassword";
import CustomerRegForm from "./components/security/customerRegForm";
import LoginForm from "./components/security/loginForm";
import apiService from "./components/service/apiService";
import postApiService from "./components/service/postApiService";
import i18n from "./il8n/il8n";
import { setDynamicFieldList } from "./redux/dynamicFieldSlice";
import { setRouterData } from "./redux/personSlice";
import { setCompanyRouterData } from "./redux/companySlice";
import { disableSection, setDuplicateData, setScratchData, setSectionList } from "./redux/routerSlice";
import store from "./redux/store";
import "nepali-datepicker-reactjs/dist/index.css";
import ForgotPassword from "./components/security/forgotPassword";
import ResetPassword from "./components/security/resetPassword";
import CaptureVideo from "./components/kyc/CaptureVideo";
import IdleTimer from "./idleTimer";
import Biometrics from "./components/kyc/Biometrics";
import { ToastWrapper } from "./components/other/Toast";
import VideoChat from "./components/other/VideoChat";
import VideoKycSchedule from "./components/kyc/videoKycSchedule";
import mobileDashboard from "./components/dashboard/mobileDashboard";
import MoneyLaunderingPrevention from "./components/kyc/moneyLaunderingPreventionDetails";
import ApiBaseURLProps from "./components/other/apiBaseURL";
function App() {
  const [globalSetting, setGlobalSetting] = useState();
  useEffect(() => {
    const tempGlobalSetting = localStorage.getItem("globalSetting");

    if (!tempGlobalSetting) {
      apiService.getGlobalSettingPublic().then((response) => {
        if (response.data) {
          localStorage.setItem("globalSetting", JSON.stringify(response.data));
          setGlobalSetting(response.data);
        }
      });
    } else {
      try {
        const parsedSetting = JSON.parse(tempGlobalSetting);
        if (parsedSetting && typeof parsedSetting === "object") {
          setGlobalSetting(parsedSetting);
        }
      } catch (e) {
        console.error("Failed to parse globalSetting from localStorage");
      }
    }
  }, []);


  return (
    <I18nextProvider i18n={i18n}>
      <ToastWrapper>
        <div className="p-panel" style={{ height: '100vh' }}>
          <div style={{ height: '95vh', overflow: 'hidden' }}>
            <script src={"https://maps.googleapis.com/maps/api/js?key=" + ApiBaseURLProps.apiBaseURL + "&libraries=places"}></script>
            <BrowserRouter>
              <Switch>
                <Route exact path="/" render={HomePage} />
                <Route path="/kyc" component={CustomerPortal} />
                <div
                  className="compact-layout"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    placeContent: "center",
                    height: "95vh",
                    backgroundColor: "#008080",
                    overflowY: 'scroll'
                  }}
                >
                  <Route exact path="/video-kyc-schedule" component={VideoKycSchedule} />
                  <Route exact path="/change-password" component={ChangePassword} />
                  <Route exact path="/login" component={LoginForm} />
                  <Route exact path="/registration" component={CustomerRegForm} />
                  <Route path="/forgot-password" component={ForgotPassword} />
                  <Route path="/reset-password" component={ResetPassword} />
                </div>
              </Switch>
            </BrowserRouter>
          </div>
          <div className="footer" style={{
            backgroundColor: "#008080", height: '5vh', color: '#fff', padding: 0
          }}>
            <div>
              <div
                // className="p-fluid p-col-8"
                style={{ textAlign: "center" }}
              >
                {" "}
                Copyright © {globalSetting?.year} CDS and Clearing Ltd. All Rights Reserved.
              </div>
              {/* <div
                className="p-fluid p-col-4 p-md-4"
                style={{ float: "left", textAlign: "right" }}
              >
                {" "}
                Powered By PCS
              </div> */}
            </div>
          </div>
        </div>
      </ToastWrapper>
    </I18nextProvider>
  );
}

const CustomerPortal = () => {
  return (
    <Provider store={store}>
      <KycUI />
    </Provider>
  );
};

const KycUI = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { formType, permKycId, blockForm } = useSelector((state) => state.routerData);
  const isMinor = useSelector((state) => state.personalDetails.isMinor);
  const sectionList = useSelector(state => state.routerData.sectionList);

  useEffect(() => {
    postApiService
      .getCustomerUser()
      .then((response) => {
        dispatch(setScratchData(response.data))
        if (response.data.type === "C")
          dispatch(setCompanyRouterData(response.data));
        else dispatch(setRouterData(response.data));

        apiService.getDuplicateDataByCustomer(response.data?.id)
          .then(response => {
            dispatch(setDuplicateData(response.data.data.filter(dd => dd &&
              (dd.per100 != null || dd.per100nCtznDob != null || dd.per100FLNameCtznDob != null
                || dd.per100AllNameDobCtzn19 != null || dd.per100Minor != null || dd.per100Nid != null
              ))));
            // setDuplicateData(response.data.data.filter(dd => dd && (dd.duplicate100 || dd.duplicate90)));
          });
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = '/login';
        }
      });
  }, []);

  useEffect(() => {
    if (formType)
      apiService.getSectionList(formType).then((response) => {
        console.log("response  section", response.data.data);
        if (permKycId) {
          const section = response.data.data.find((s) => s.code === "BD");
          section.status = "D";
        }
        const sectionBID = response.data.data.find((s) => s.code === "BID");
        sectionBID.status = "D";

        dispatch(setSectionList(response.data.data));

        apiService.getDynamicFieldList().then((response2) => {
          console.log("response dynamic", response2.data.data);
          dispatch(setDynamicFieldList(response2.data.data));
        });
      });
  }, [formType]);

  useEffect(() => {
    if (sectionList && sectionList.length)
      dispatch(disableSection({ code: "GD", flag: !isMinor }));
  }, [isMinor, sectionList && sectionList.length]);

  return (
    <>{(!formType || blockForm) && <div className="loading-div"></div>}
      <IdleTimer />
      <Switch>
        <Route exact path="/kyc/mobileDashboard" component={mobileDashboard} />
        <Route exact path="/kyc/dashboard" component={Dashboard} />
        <Route exact path="/kyc/view" component={KycView} />
        <Route exact path="/kyc/video-kyc" component={VideoChat} />
        <Route path="/kyc" component={Kyc} />
      </Switch>
    </>
  );
};

const HomePage = () => {
  const accessToken = sessionStorage.getItem("access_token");

  if (accessToken) return <Redirect to="/kyc/dashboard" />;
  else return <Redirect to="/login" />
};

const Kyc = ({ router, match }) => {
  const toast = useRef();

  return (
    <div className="p-grid" style={{ height: "95vh" }}>
      <div id="kycForm" style={{ height: "95vh" }} className="p-col-12 p-md-9 compact-layout">
        <div id="kycFormInner"
          style={{ height: "94vh" }}
          className="p-col-12 p-md-12"
        >
          <Switch>
            <Route
              exact
              path={`${match.path}`}
              component={DefaulKycComponent}
            />
            <Route
              exact
              path={`${match.path}/person`}
              component={PersonalDetails}
            />
            <Route
              exact
              path={`${match.path}/boid`}
              component={BoidDetails}
            />
            <Route exact path={`${match.path}/money-laundering-prevention`}
              component={MoneyLaunderingPrevention} />
            <Route
              exact
              path={`${match.path}/address`}
              component={AddressDetails}
            />
            <Route
              exact
              path={`${match.path}/family`}
              component={FamilyDetails}
            />
            <Route
              exact
              path={`${match.path}/bank`}
              component={BankDetails}
            />
            <Route
              exact
              path={`${match.path}/occupation`}
              component={OccupationDetails}
            />
            <Route
              exact
              path={`${match.path}/guardian`}
              component={GuardianDetails}
            />
            <Route
              exact
              path={`${match.path}/document`}
              component={DocumentDetails}
            />
            <Route
              exact
              path={`${match.path}/identity`}
              component={IdentityDetails}
            />
            <Route
              exact
              path={`${match.path}/decleration`}
              component={Decleration}
            />
            <Route
              exact
              path={`${match.path}/company`}
              component={CompanyDetails}
            />
            <Route
              exact
              path={`${match.path}/director`}
              component={DirectorDetails}
            />
            <Route
              exact
              path={`${match.path}/organization`}
              component={OrganizationLookup}
            />
            <Route
              exact
              path={`${match.path}/biometrics`}
              component={Biometrics}
            />
            <Route
              exact
              path={`${match.path}/video`}
              component={CaptureVideo}
            />
          </Switch>
        </div>
      </div>
      <KycSideBar />
      <Toast ref={toast}></Toast>
    </div>
  );
};

const DefaulKycComponent = ({ match }) => {
  const formType = useSelector((state) => state.routerData.formType);
  const url = match.path + (formType === "C" ? "/company" : "/person");
  return <Redirect to={url} />;
};

export default App;
